import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";
import {saveAs} from "file-saver";

const downloadRoutes = {
    DOWNLOAD_FILE: "global/downloads/"
}
export default {
    downloadFile(data) {
        let a = document.createElement("a");
        const urlFile =
            process.env.VUE_APP_URL + downloadRoutes.DOWNLOAD_FILE + data;
        a.href = urlFile;
        document.body.appendChild(a);
        a.download = urlFile;
        a.click();
    },
    /**
     * Descarga un archivo directamente desde axios
     * @param uri
     * @param responseType
     * @param fileName
     * @param fileExtension
     * @param objParams
     * @returns {Promise<unknown>}
     */
    downloadFileByAxios(uri,
                        responseType,
                        fileName,
                        fileExtension,
                        objParams) {
        return new Promise((resolve, reject) => {
            http.get(uri, {
                params: objParams,
                responseType: 'arraybuffer'
            }).then((response) => {
                const file = new Blob([response.data], {type: responseType});
                saveAs(file, fileName, fileExtension);
                resolve(response);
            }).catch((error) => {
                toast.error("No se pudo realizar la conexión con el servidor");
                reject(error);
            });
        });
    }
}
